import { render, staticRenderFns } from "./CreateProductForm.vue?vue&type=template&id=7b80d9d5"
import script from "./CreateProductForm.vue?vue&type=script&lang=ts"
export * from "./CreateProductForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports